import { Field, Checkbox } from '@chakra-ui/react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

interface FormCheckboxProps {
  name: string;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  helperText?: string;
  disabled?: boolean;
}

const FormCheckbox = ({
  name,
  label,
  control,
  errors,
  helperText,
  disabled = false,
}: FormCheckboxProps) => {
  const fieldError = errors[name];
  const isInvalid = !!fieldError;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Field.Root invalid={isInvalid} disabled={disabled || field.disabled}>
          <Checkbox.Root
            checked={field.value}
            onCheckedChange={({ checked }) => field.onChange(checked)}
          >
            <Checkbox.HiddenInput />
            <Checkbox.Control />
            <Checkbox.Label>{label}</Checkbox.Label>
          </Checkbox.Root>
          {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
          {isInvalid && fieldError?.message && (
            <Field.ErrorText>
              {typeof fieldError.message === 'string' ? fieldError.message : 'Invalid input'}
            </Field.ErrorText>
          )}
        </Field.Root>
      )}
    />
  );
};

export default FormCheckbox;
